const globalCanvas = document.createElement("canvas");
const globalWaterMark = document.createElement("div");
let waterMarkObserver = null;
let waterMarkStyle = "";
let resizeHandler = null;

// 定义指令配置项
export default {
    // 初始化设置
    bind(el, binding, vnode) {
        binding.def?.init(el, binding);
    },
    // 元素插入父元素时调用
    inserted(el, binding, vnode) {},
    // 组件更新时调用
    update(el, binding, vnode) {},
    // 组件及子组件更新后调用
    componentUpdated(el, binding, vnode) {},
    // 解绑时调用
    unbind(el, binding, vnode) {
        // 停止观察。调用该方法后，DOM 再发生变动，也不会触发观察器
        waterMarkObserver && waterMarkObserver.disconnect();
        // 移除水印元素
        const waterMarkEl = document.querySelector(`.${binding.def?.waterMarkName() || binding.dir?.waterMarkName()}`);
        if (waterMarkEl) {
            waterMarkEl.remove();
        }
        // 移除 resize 事件监听
        if (resizeHandler) {
            window.removeEventListener('resize', resizeHandler);
        }
    },
    /**
     * 初始化水印
     * @param el
     * @param binding
     */
    init(el, binding) {
        // 设置水印
        binding.def?.setWaterMark(el, binding) || binding.dir?.setWaterMark(el, binding);
        // 启动监控
        binding.def?.createObserver(el, binding) || binding.dir?.createObserver(el, binding);
        // 监听窗口大小变化
        resizeHandler = this.debounce(() => {
            binding.def?.setWaterMark(el, binding) || binding.dir?.setWaterMark(el, binding);
        }, 100);
        window.addEventListener('resize', resizeHandler);
    },
    /**
     * 默认配置
     * @returns {{fontFamily: string, color: string, size: number, text: string}}
     */
    defaultOptions() {
        return {
            // 水印文字
            text: "默认水印",
            // 水印文字颜色
            color: "rgba(150, 150, 150, 0.1)",
            // 水印字体大小
            size: 14,
            // 水印字体类型
            // fontFamily: 'Arial'
        };
    },
    /**
     * 水印容器class名
     * @returns {string}
     */
    waterMarkName() {
        return "kms-water-mark";
    },
    /**
     * 水印容器样式
     * @param height
     * @returns {string}
     */
    waterMarkStyle(height) {
        const style = {
            display: "block",
            overflow: "hidden",
            position: "fixed", // 使用 fixed 使水印固定在视口
            left: "0px",
            top: "0px",
            "z-index": 100000,
            "font-size": "14px",
            "background-repeat": "repeat",
            "background-position": "center",
            "pointer-events": "none",
            width: "100%",
            height: height || "100vh", // 使用 100vh 表示屏幕高度
            "background-size": "150px 100px", // 设置背景图片的大小，与 canvas 大小一致
        };
        const styleArr = Object.keys(style).map((key) => {
            return `${key}:${style[key]}`;
        });
        return styleArr.join(";") + ";";
    },
    /**
     * 设置水印
     * @param el
     * @param binding
     */
    setWaterMark(el, binding) {
        // 移除之前的水印元素
        const existingWaterMark = document.querySelector(`.${binding.def?.waterMarkName() || binding.dir?.waterMarkName()}`);
        if (existingWaterMark) {
            existingWaterMark.remove();
        }

        // 拼接配置
        let defaultOptions = binding.def?.defaultOptions() || binding.dir?.defaultOptions();
        if (Object.prototype.toString.call(binding.value) === "[object Object]") {
            defaultOptions = Object.assign(defaultOptions, {
                text: binding.value.text || defaultOptions.text,
                color: binding.value.color || defaultOptions.color,
                size: binding.value?.size?.toString().replace("px", "") || defaultOptions.size,
                fontFamily: binding.value.fontFamily || defaultOptions.fontFamily,
            });
        }
        // 获取对应的 canvas 画布相关的 base64 url
        const url = binding.def?.getDataUrl(defaultOptions) || binding.dir?.getDataUrl(defaultOptions);
        // 创建 waterMark 父元素
        const waterMark = globalWaterMark || document.createElement("div");
        waterMark.className = binding.def?.waterMarkName() || binding.dir?.waterMarkName(); // 方便自定义展示结果
        // 获取屏幕高度
        const screenHeight = window.innerHeight + 'px';
        waterMarkStyle = `${
            binding.def?.waterMarkStyle(screenHeight) || binding.dir?.waterMarkStyle(screenHeight)
        };background-image: url(${url})`;
        waterMark.setAttribute("style", waterMarkStyle);
        // 将水印元素添加到 body 中
        document.body.appendChild(waterMark);
    },
    /**
     * 生成水印图片，返回一个包含图片展示的数据 URL
     * @param options
     * @returns {string} 水印图片：base64-url
     */
    getDataUrl(options) {
        const { text, size, fontFamily, color } = options;
        const rotate = -20;
        const canvas = globalCanvas || document.createElement("canvas");
        const ctx = canvas.getContext("2d"); // 获取canvas画布的绘图环境
        canvas.width = 150; // 减小单个水印的宽度
        canvas.height = 100; // 减小单个水印的高度

        ctx.fillStyle = "rgba(0, 0, 0, 0)"; // 背景填充色
        ctx.fillRect(0, 0, 100, 50); // 填充区域大小

        ctx.save();
        ctx.font = `${size}px ${fontFamily}`; // 文字字体大小
        ctx.fillStyle = color; // 文字颜色
        ctx.translate(100 / 2, 50 / 2); // 平移，旋转的中心点
        ctx?.rotate((rotate * Math.PI) / 360); // 水印旋转角度
        ctx.textBaseline = "middle"; // 垂直居中
        ctx.textAlign = "center"; // 水平居中
        ctx?.fillText(text, 0, 0);
        ctx.restore();
        ctx.clip();
        return canvas.toDataURL("image/png");
    },
    /**
     * 添加观察者，监听DOM变化，用 MutationObserver 对水印元素进行监听，删除、属性变化时，再立即生成一个水印元素
     * @param el
     * @param binding
     */
    createObserver(el, binding) {
        const className = binding.def?.waterMarkName() || binding.dir?.waterMarkName();
        const waterMarkEl = document.querySelector(`.${className}`);
        waterMarkObserver = new MutationObserver((mutationsList) => {
            if (mutationsList.length) {
                const { removedNodes, type, target } = mutationsList[0];
                const currStyle = waterMarkEl?.getAttribute("style");
                // 证明被删除了
                if (removedNodes[0] === waterMarkEl) {
                    // 停止观察。调用该方法后，DOM 再发生变动，也不会触发观察器
                    waterMarkObserver.disconnect();
                    // 重新初始化（设置水印，启动监控）
                    binding.def?.init(el, binding) || binding.dir?.init(el, binding);
                } else if (
                    type === "attributes" &&
                    target === waterMarkEl &&
                    currStyle !== waterMarkStyle
                ) {
                    waterMarkEl.setAttribute("style", waterMarkStyle);
                }
            }
        });
        waterMarkObserver.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeOldValue: true,
        });
    },
    /**
     * 节流函数
     * @param func
     * @param wait
     * @returns {Function}
     */
    debounce(func, wait) {
        let timeout;
        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }
};
